export default "<style>\n  .-invisible\n  {\n    display: none;\n  }\n  \n</style>";